import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANGS, setLang, useLang } from "@/lib/i18n";

export const LanguageSelect = ({ className = "", testId = "language-select" }) => {
  const lang = useLang();
  return (
    <div translate="no" className={className}>
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger data-testid={testId} aria-label="Lingua" className="h-9 w-[132px] gap-1.5 rounded-full border-slate-200 bg-white text-sm">
          <Globe className="h-4 w-4 shrink-0 text-slate-500" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent translate="no">
          {LANGS.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>{l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
